module.exports = require('../_components/@alicd/next-menu/lib/index.js');


//////////////////
// WEBPACK FOOTER
// ./node_modules/_@alicd_next@0.19.78@@alicd/next/lib/menu/index.js
// module id = 109
// module chunks = 0